import { Link, Typography } from "@mui/material";
import { routesConfig } from "config/app-config";
import type { Antenne, Centre } from "models";
import type { ReactNode } from "react";

interface CentreAntenneSpanProps {
  centreOuAntenne: Centre | Antenne;
}
function CentreAntenneSpan({ centreOuAntenne }: Readonly<CentreAntenneSpanProps>): ReactNode {
  return (
    <Typography component="span">
      {centreOuAntenne.idCommuneAdresse == null || centreOuAntenne.idCommuneAdresse === "" ? (
        centreOuAntenne.libelle
      ) : (
        <Link href={routesConfig.commune.getParameterPath(centreOuAntenne.idCommuneAdresse)}>
          {centreOuAntenne.libelle}
        </Link>
      )}
    </Typography>
  );
}

export default CentreAntenneSpan;
